import { BuscarCautelasCarrinhoDto } from "@/dtos/Request/RequestBuscarCautelasCarrinho"
import { FinalizarCompraResumo } from "./FinalizarCompraResumo"
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { FinalizarCompraTermos } from "./FinalizarCompraTermos";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DadosCompraPixDto } from "@/dtos/Request/RequestDadosCompraCartaoCreditoDto";
import { FormasPagamento } from "@/dtos/FormasPagamento";
import CompraService from "@/services/CompraService";
import { toast } from "@/components/ui/use-toast";
import { useCarrinho } from "@/contexts/CarrinhoProvider";
import { QrCodeGeradoDto } from "@/dtos/QrCodeGeradoDto";
import AppService from "@/services/AppService";
import StorageUtils from "@/utils/StorageUtils";
import { DrawerPagamentoParaOutraPessoa } from "./DrawerPagamentoParaOutraPessoa";
import { PresenteadoDto } from "@/services/AcessoService";


interface FinalizarCompraPixProps {
    dadosResumo: BuscarCautelasCarrinhoDto,
    token?: string,
    presenteados: PresenteadoDto[],
    handlePresenteados: (action: 'remove' | 'load', presenteado?: PresenteadoDto) => void,
}

export function FinalizarCompraPix(props: FinalizarCompraPixProps) {
    const [termosAceito, setTermosAceito] = useState(false);
    const [realizandoPagamento, setRealizandoPagamento] = useState(false);
    const navigate = useNavigate();
    const { atualizarQuantidadeCarrinho } = useCarrinho();
    const [searchParams] = useSearchParams();

    async function handleAceitarTermos(termos: boolean) {
        setTermosAceito(termos);
    }

    async function handleFinalizarCompra() {
        try {
            setRealizandoPagamento(true);

            let idPresenteado: number | undefined = undefined;
            const getIdPessoaPresenteada = searchParams.get('idPessoaPresenteada');

            if (getIdPessoaPresenteada) {
                idPresenteado = Number(getIdPessoaPresenteada);
            }

            let idVendedor = StorageUtils.getIdVendedor();

            const dadosPagamento: DadosCompraPixDto = {
                Origem: 'Web',
                Cautelas: props.dadosResumo.Cautelas.map(c => c.IdCautela),
                FormaPagamento: FormasPagamento.Pix,
                IdentificadorDispositivo: await StorageUtils.getDispositivo(),
                IdPresenteado: idPresenteado,
                IdVendedor: idVendedor
            }

            let result: QrCodeGeradoDto = {} as QrCodeGeradoDto;

            if (props.token) {
                const { Data } = await AppService.FinalizarCompraPixApp(dadosPagamento, props.token);
                result = Data;
            } else {
                const { Data } = await CompraService.FinalizarCompraPix(dadosPagamento);
                result = Data;
            }

            toast({
                variant: 'success',
                description: 'QRCode gerado com sucesso!',
                duration: 4000
            })

            StorageUtils.removeIdVendedor();

            let urlNavigate = '/compra/finalizar/qrcode/'

            if (props.token) {
                urlNavigate += '?origem=ios'
            }

            await navigate(urlNavigate, {
                state:
                    { ...result } as QrCodeGeradoDto
            });

            if (!props.token) {
                await atualizarQuantidadeCarrinho();
            }
        } catch (error: any) {
            setRealizandoPagamento(false);
            toast({
                variant: 'destructive',
                description: error,
                duration: 4000
            });
        }
    }

    return (
        <div className="md:w-5/12">
            <div className="flex flex-col md:flex-row">
                <FinalizarCompraResumo dadosResumo={props.dadosResumo} />
            </div>
            <div className="flex flex-col gap-5">
                <DrawerPagamentoParaOutraPessoa handlePresenteados={props.handlePresenteados} presenteados={props.presenteados} />
                <FinalizarCompraTermos aceitarTermos={handleAceitarTermos} termosAceito={termosAceito} />
                <Button
                    className="w-full"
                    size="xl"
                    disabled={!termosAceito || realizandoPagamento}
                    onClick={handleFinalizarCompra}
                    variant="default">
                    {
                        realizandoPagamento ? (<>Realizando Pagamento...</>) : (<>Pagar com PIX</>)
                    }
                </Button>
            </div >
        </div >
    )
}